<template>
  <v-container fluid>
      <v-form ref="fm_eft">
        <div class='font-weight-bold'>ACH Payment Details</div>
        <p style="font-size:0.75em;line-height:1.25em;">Pay your dues by setting up an ACH-Bank Draft. Choosing this option saves MEA money on payment processing fees which allows us to put more of your dues dollars to work advocating for you.</p>
        <billhighway-billing-info style="font-size:0.75em;line-height:1.25em;"></billhighway-billing-info>
        <v-row  class='mt-2'>
          <v-col cols="12" sm="6" class='py-0'>
            <v-text-field
              ref="oma_pmt_eft_bank_name"
              v-model="oma_pmt_eft_bank_name"              
              :rules="rules.oma_pmt_eft_bank_name"  
              v-on:change="update_app_record('oma_pmt_eft_bank_name')"
              hint="ex. MSUFCU"
            >
              <template #label>
                Bank Name<span class="required red--text">*</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class='py-0'>
            <v-text-field
              ref="oma_pmt_eft_act_holder_name"
              v-model="oma_pmt_eft_act_holder_name"              
              :rules="rules.oma_pmt_eft_act_holder_name"
              v-on:change="update_app_record('oma_pmt_eft_act_holder_name')"
            >
              <template #label>
                Account Holders Name<span class="required red--text"> *</span>
              </template>
            </v-text-field>
          </v-col>          
        </v-row>
        <v-row>
          <v-col cols="12" sm="4" class='py-0'>
            <v-text-field
              ref="oma_pmt_eft_route_num"
              v-model="oma_pmt_eft_route_num"              
              :rules="rules.oma_pmt_eft_route_num"              
              v-on:change="update_app_record('oma_pmt_eft_route_num')"
            >
              <template #label>
                Bank Routing Number<span class="required red--text"> *</span>
              </template>
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="8" class='py-0'>
            <v-text-field
              ref="oma_pmt_eft_act_num"
              v-model="oma_pmt_eft_act_num"              
              :rules="rules.oma_pmt_eft_act_num"              
              v-on:blur="update_app_record('oma_pmt_eft_act_num')"
            >
              <template #label>
                Bank Account Number<span class="required red--text"> *</span>
              </template>
            </v-text-field>
          </v-col> 
        </v-row>
        <v-row>
          <v-col cols="12" class='py-0'>
            <div>Which type of account is this?<span class="required red--text"> *</span></div>
            <v-radio-group
              ref="oma_pmt_eft_act_type"
              v-model="oma_pmt_eft_act_type"              
              :rules="rules.oma_pmt_eft_act_type"
              v-on:change="update_app_record('oma_pmt_eft_act_type')"
              row
              class='mt-0 mb-1'
            >
              <v-radio
                  label="Savings"
                  value="sav"
              ></v-radio>
              <v-radio
                  label="Checking"
                  value="chk"
              ></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-form>
  </v-container>
</template>

<script>
  import commonMixins from '@/mixins/commonMixins';
  import BillhighwayBillingInfo from './BillhighwayBillingInfo.vue'
  //import axios from 'axios'
  export default {
    name: 'IblEft',
    components: {BillhighwayBillingInfo},
    mixins:[commonMixins],
    data:() => ({          
      rules: {
        oma_pmt_eft_bank_name: [
          v => !!v || 'Bank Name is required',
          v => /^[\w'\s.-]+$/.test(v) || 'Bank Name is invalid'
        ],
        oma_pmt_eft_act_holder_name: [
          v => !!v || 'Account Holder Name is required',
          v => /^[\w'\s.-]+$/.test(v) || 'Account Holder Name is invalid'
        ],
        oma_pmt_eft_act_type: [
          v => !!v || 'Account Type is required',
          v => /^[A-z]{1,3}$/.test(v) || 'Account Type is invalid'
        ],
        oma_pmt_eft_route_num: [
          v => !!v || 'Routing Number is required',
          v => /^\d{9}$/.test(v) || 'Routing Number is invalid'
        ],
        oma_pmt_eft_act_num: [
           v => !!v || 'Account Number is required',
           v => /^\d{2,17}$/.test(v) || 'Account Number is invalid'
        ]
      }
    }),
    methods:{
      /*
      async update_app_record(name){
          if(this.$refs[name] && !this.$refs[name].valid) return false;             
          const value = this[name];
          const update = await axios.post(`${this.$baseURL}/common/application/`, 
              JSON.stringify({doCmd:'update_app_record', app_id: window.sessionStorage.getItem('appID'), field: name, value: value}), {
              headers : {'Content-Type': 'application/json'}
          });
          const {data:{error, errortext}} = update;
          if(error > 0){
              this.showError = true;
              this.errorObj = {error:error, errortext:errortext};
              this.errorIsFatal=false;
              return;
          }

          if(name == 'oma_pmt_eft_act_num'){
            this.update_app_record('oma_pmt_eft_act_num_last4');
          }
      }*/      
    },
    computed:{
      oma_pmt_eft_act_type:{
        get(){
            return this.$store.state.oma_pmt_eft_act_type;
        },
        set(value){
            this.$store.state.oma_pmt_eft_act_type = value;
        }
      },
      oma_pmt_eft_act_num:{
        get(){
            return this.$store.state.oma_pmt_eft_act_num;
        },
        set(value){          
            this.$store.state.oma_pmt_eft_act_num = value;
            this.update_app_record('oma_pmt_eft_act_num_last4');
        }
      },
      oma_pmt_eft_route_num:{
        get(){
            return this.$store.state.oma_pmt_eft_route_num;
        },
        set(value){
            this.$store.state.oma_pmt_eft_route_num = value;
        }
      },
      oma_pmt_eft_act_holder_name: {
        get(){
            return this.$store.state.oma_pmt_eft_act_holder_name;
        },
        set(value){
            this.$store.state.oma_pmt_eft_act_holder_name = value;
        }
      },
      oma_pmt_eft_bank_name: {
        get(){
            return this.$store.state.oma_pmt_eft_bank_name;
        },
        set(value){
            this.$store.state.oma_pmt_eft_bank_name = value;
        } 
      },
      oma_pmt_eft_act_num_last4:{
        get(){
          return this.$store.getters.getEFTActLast4;
        }        
      }
    }
  }
</script>

<style scoped>
</style>